module.exports = __webpack_public_path__ + "static/media/modulo-tienda.80f04abf.jpg";